<template>
    <div class="s-mask s-sqsy hide" id="j-sqsy">
        <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="s-box">
            <div class="s-top"><img class="s-close" src="../assets/close.svg" alt=""></div>
            <div class="s-title">
                <p>申请试用</p>
                <span>请留下您的信息，以便我们为您提供服务</span>
            </div>
            <ul class="s-form">
                <li class="s-form_item">
                    <label for="">您的姓名：</label>
                    <div class="s-input_box"><input id="sy-name" class="s-input" type="text"></div>
                </li>
                <li class="s-form_item">
                    <label for="">手机号：</label>
                    <div class="s-input_box"><input id="sy-phone" class="s-input" type="text"></div>
                </li>
                <li class="s-form_item">
                    <label for="">验证码：</label>
                    <div class="s-input_box2">
                        <div class="s-input_box"><input id="sy-code" class="s-input" type="text"></div>
                        <div class="s-btn2" id="j-get_code">获取验证码</div>
                    </div>
                </li>
                <li class="s-form_item">
                    <label for="">微信号：</label>
                    <div class="s-input_box"><input id="sy-wx" class="s-input" type="text"></div>
                </li>
                <li class="s-form_item">
                    <label for="">公司名称：</label>
                    <div class="s-input_box"><input id="sy-company" class="s-input" type="text"></div>
                </li>
            </ul>
            <div class="s-btn" id="sy_sub">立即提交</div>
            <div class="div3">
                <span>或添加微信与我们联络</span>
                <div>
                    <img src="../assets/image/newCode.png" alt="">
                </div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="s-box">
            <div class="s-top"><img class="s-close" src="../assets/close.svg" alt=""></div>
            <div class="s-title">
                <p>Apply for a trial</p>
                <span>Please leave your information so we can serve you!</span>
            </div>
            <ul class="s-form">
                <li class="s-form_item">
                    <label for="">Your Name：</label>
                    <div class="s-input_box"><input id="sy-name" class="s-input" type="text"></div>
                </li>
                <li class="s-form_item">
                    <label for="">Phone number：</label>
                    <div class="s-input_box"><input id="sy-phone" class="s-input" type="text"></div>
                </li>
                <li class="s-form_item">
                    <label for="">CAPTCHA：</label>
                    <div class="s-input_box2">
                        <div class="s-input_box"><input id="sy-code" class="s-input" type="text"></div>
                        <div class="s-btn2" id="j-get_code">Get CAPTCHA</div>
                    </div>
                </li>
                <!-- <li class="s-form_item">
                    <label for="">微信号：</label>
                    <div class="s-input_box"><input id="sy-wx" class="s-input" type="text"></div>
                </li> -->
                <li class="s-form_item">
                    <label for="">Company Name：</label>
                    <div class="s-input_box"><input id="sy-company" class="s-input" type="text"></div>
                </li>
            </ul>
            <div class="s-btn" id="sy_sub">Submit Now</div>
            <div class="div3">
                <span>Or add WeChat to contact us</span>
                <div>
                    <img src="../assets/image/newCode.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import $ from 'jquery';
  export default {
    data(){
        return {
            aaaa:true,
            regex:/^1\d{10}$/,
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
    mounted(){
        var that = this
        $('#ljsy').on('click',function(){
                console.log("444",$('#ljsy'));
                console.log("999",$('#ljsy').attr('data-type'));
                
                $('#j-sqsy.s-mask ').removeClass('hide')
                
            })
            $('#j-sqsy .s-close').on('click',function(){
                $('#j-sqsy.s-mask ').addClass('hide')
            })
            if($("element").css("display") != 'none'){
                let time = 0
            $('#j-get_code').on('click',function(){
                console.log('phone', $('#sy-phone'),$('#sy-phone').val());
                
                let phone = $('#sy-phone').val()
                that.regex = /^1\d{10}$/;
                if(!that.regex.test(phone)){
                    console.log('that',that.$message);
                    that.$message({
                        message: that.langluageType == 'ch'?'请输入正确的手机号':'Please enter the correct phone number',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        offset: '320px',
                        duration:1400
                    });
                    return
                }
                if(time <= 0){
                    time = 60
                    $.ajax({
                        type: "get",
                        url: "https://www.exposaas.com/web/propaganda/send-msg",
                        data: {
                            phone: phone
                        },
                        dataType: 'json',
                    }).then(res=>{
                        if(res.Code == 200){
                            timer()
                        }else{
                            time = 0
                        }
                    })
                }
            })
            function timer(){
                if(time>0){
                    $("#j-get_code").addClass("off").html("("+time+")s");
                    setTimeout(function(){
                        time--;
                        timer();
                    },1400);
                }else{
                    $("#j-get_code").removeClass("off").html("获取验证码");
                }
            }
            $('#sy_sub').on('click',function(){
                let data = {
                    name: $('#sy-name').val(),
                    phone: $('#sy-phone').val(),
                    wechat: $('#sy-wx').val(),
                    company_name: $('#sy-company').val(),
                    type_name: $('#ljsy').attr('data-type'),
                    code: $('#sy-code').val()
                }
                if(!data.name){
                    that.$message({
                        message: that.langluageType == 'ch'?'请输入姓名':'Please enter your name',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        duration:1400
                    });
                }else if(!data.phone){
                    that.$message({
                        message: that.langluageType == 'ch'?'请输入手机号':'Please enter your phone number',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        duration:1400
                    });
                }else if(data.phone && !that.regex.test(data.phone)){
                    that.$message({
                        message: that.langluageType == 'ch'?'请输入正确的手机号':'Please enter the correct phone number',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        duration:1400
                    });
                }else if(data.phone && that.regex.test(data.phone) && !data.code){
                    that.$message({
                        message: that.langluageType == 'ch'?'请输入验证码':'Please enter captcha',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        duration:1400
                    });
                }else if(!data.company_name){
                    that.$message({
                        message:  that.langluageType == 'ch'?'请输入公司名称':'Please enter the company name',
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        duration:1400
                    });
                }else{
                    sub_ljsy(data)
                }
            })
            function sub_ljsy(data){
                $.ajax({
                    type: "get",
                    url: "https://www.exposaas.com/web/propaganda/apply-try",
                    data: data,
                    dataType: 'json',
                }).then(res=>{
                    if(res.Code == 200){
                        that.$message({
                            message: that.langluageType == 'ch'?'提交申请成功':'Successfully submitted application',
                            center: true,
                            type:'success',
                            customClass:'mestyle',
                            offset: '320px',
                            duration:1400
                        })
                        $('#j-sqsy.s-mask ').addClass('hide')
                        // location.href = $('#ljsy').attr('data-href')
                        $('#sy-name').val('')
                        $('#sy-phone').val('')
                        $('#sy-wx').val('')
                        $('#sy-company').val('')
                        $('#sy-code').val('')
                        time = 0
                    }else{
                        // layer.msg(res.msg,{ offset: '320px' });
                        that.$message({
                        message: res.msg,
                        center: true,
                        type:'error',
                        customClass:'mestyle',
                        offset: '320px',
                        duration:1400
                    });
                    }
                })
            }
            }
            
    },
}
</script>


// WEBPACK FOOTER //
// src/components/dialog.vue